import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

function Error404 (props) {
  return (
    <div>
      <h2 className='error404'>The page {props.location.pathname} does not exist!</h2>
      <h3 className='error404'>Would you like to return <Link to="/">home</Link> instead?</h3>
    </div>
  )
}
Error404.propTypes = {
  location: PropTypes.object
}

export default Error404



// WEBPACK FOOTER //
// ./src/components/Error404/Error404.js